
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services'

const statusMap = {
    resolve: { 
        value: 2, name: '已通过' 
    },
    notCheck: { 
        value: 1, name: '未审核'
    },
    reject: { 
        value: 3, name: '不通过' 
    }
}

@Component({
    name: 'media-store-detail',
    components: {
        CreateDetailLayout,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private changeLoading = false
    private statusMap = statusMap
    private detail = {
        status: {
            id: 0,
            name: ''
        }
    }

    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        this.getStoreDetail()
    }

    private matchButtonType(status: number) {
        return this.detail.status.id === status ? 'primary' : 'default'
    }

    private async getStoreDetail() {
        const params = { id: this.detailId }
        const result = await MediaService.getStoreDetail(params)
        if (result.status === 200) {
            this.detail = result.data
        }
    }

    // 改变状态
    private async changeStatus(status: { value: number, name: string }) {
        const params = {
            id: this.detailId,
            status: status.value
        }
        const result = await MediaService.updateStoreStatus(params)
        if (result.status === 200) {
            this.detail.status = { id: status.value, name: status.name }
            return this.$msuccess('修改状态成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
